module.exports = __webpack_public_path__ + "img/mapa-home-min.a4d1c690.jpg";